<template lang="pug">
  .step
    h1 本人に現在ご存命の父母はいますか
    .message_area
      .msg 父母が既に他界して祖父母がご存命の場合は「はい」を選択してください（次の画面で祖父母を追加できます）
      .msg 父母どちらかが他界している場合も「はい」を選択してください。
    .button_area
      button(@click="button_yes_click") はい
      button(@click="button_no_click") いいえ
    .button_area
      BackButton
    .family_message 下に相続関係図が表示されます
</template>

<script lang="js">
import BackButton from '@/components/module/BackButton.vue';

export default {
  components: {
    BackButton,
  },
  mounted() {
    this.$emit('init_parent');
  },
  methods: {
    button_yes_click() {
      this.$emit('family_type', 2);
      this.$emit('append_parent', '');
      this.$router.push('/parent_input');
    },
    button_no_click() {
      this.$emit('family_type', 3);
      this.$router.push('/step01_4');
    },
  },
};
</script>

<style lang="sass" scoped>
@import "../../assets/sass/component/step_style"
.message_area
  padding: 0 20px
  .msg
    font-size: 12px
    position: relative
    padding-left: 14px
    color: $clear-red
    &:before
      content: "※"
      position: absolute
      left: 0
</style>